import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import StatusButton from '../../../../../../../../../../../../../components/StatusButton';
import { getStatusButtonMenuOptions } from '../../../../../../../../../../../../../components/StatusButton/reactQueryUtil';
import { CypressIds } from '../../../../../../../../../../../../../constants/cypressIds';
import { InsuredProfilePageDuskIds } from '../../../../../../../../../../../../../constants/duskIds';
import { useUpdateRecordRequirements } from '../../../../../../../../../../../../../services/record-service';

import BaseDocumentCell from './BaseDocumentCell';

const EmptyStatusCell = ({ requirement, recordId, insuredId }) => {
  const {
    id,
    insuranceDocumentTypeId,
    status,
    jobId
  } = requirement;

  const { mutate: updateRequirementStatus } = useUpdateRecordRequirements({ recordId, insuredId });

  const duskSelector = useMemo(() => InsuredProfilePageDuskIds.getDocumentRequirementStatusButton(insuranceDocumentTypeId), [requirement]);
  const docStatusOptions = getStatusButtonMenuOptions(status, 'documents');

  return (
    <StatusButton
      cypressId={CypressIds.documentStatusButton(insuranceDocumentTypeId)}
      duskSelector={duskSelector}
      id={id}
      isLoading={requirement?.isLoading}
      metadata={{
        documentTypeId: insuranceDocumentTypeId,
        jobId,
        insuredId,
        recordId,
        updateRequirementStatus
      }}
      options={docStatusOptions}
    />
  );
};

EmptyStatusCell.propTypes = {
  requirement: PropTypes.shape({
    status: PropTypes.string,
    id: PropTypes.number,
    insuranceDocumentTypeId: PropTypes.number,
    jobId: PropTypes.number,
    isLoading: PropTypes.bool
  }),
  recordId: PropTypes.number.isRequired,
  insuredId: PropTypes.number.isRequired
};

export default BaseDocumentCell(EmptyStatusCell);
